import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { PoliciesPage } from '@/features/ai/agents/agents-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Administration → « Agents » : politiques des jetons machine (ADR 0080 §6). */
export const Route = createFileRoute('/$tenant/agent-policies/')({ component: PoliciesRoute });

function PoliciesRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="agentPolicies"
      crumbs={[{ label: t('nav.items.agentPolicies') }]}
    >
      <PoliciesPage tenantId={tenant} />
    </ConsoleShell>
  );
}
